<template><RecommendationForm /></template>
<script>
import RecommendationForm from "@/components/Dashboard/FCO/Recommendations/RecommendationForm.vue";
export default {
  name: "recommendationForm",
  components: { RecommendationForm },
};
</script>
